




















import { Component, Vue } from 'vue-property-decorator';

import ElementSearchPatient from '@/components/elements/ElementSearchPatient.vue';
import ElementSignOutButton from '@/components/elements/ElementSignOutButton.vue';
import ElementAccountButton from '@/components/elements/ElementAccountButton.vue';
import ElementBreadcrumbs from '@/components/elements/ElementBreadcrumbs.vue';
import { StepsKeys } from '@/plugins/podolib/services/analysis';

@Component({
  components: {
    ElementBreadcrumbs,
    ElementAccountButton,
    ElementSignOutButton,
    ElementSearchPatient,
  },
})
export default class BaseNavbar extends Vue {}
